import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FindErrorItem, FindLoad, FindSuccessItem, IsImageLoaded, useModal } from 'utils';
import { Images } from 'assets';
import { formActions, httpRequestsOnSuccessActions } from 'store';
import { Loader, MinLoader } from 'components';
import { FormBuilder } from '../../forms';

const ACTION_TYPE = 'GET_CLIENT_INVITE_FORM';
const SAVE_ACTION_TYPE = 'SAVE_INVITE_FORM';
const REQUEST_INVITE_FORM = 'REQUEST_INVITE_FORM';
const tokenIsInvalid = 'Token is invalid, request another reset';
const tokenIsExpired = 'Token is expired, request another reset';
export const ClientInviteForm = ({}) => {
    const clientInviteForm = useSelector((state) => state.forms.clientInviteForm);
    const { open } = useModal();
    const navigate = useNavigate();
    const imageLoaded = IsImageLoaded(Images.authImage);
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const loadInviteForm = FindLoad(REQUEST_INVITE_FORM);
    const successInviteForm = FindSuccessItem(REQUEST_INVITE_FORM);
    const success = FindSuccessItem(SAVE_ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const { search, pathname } = useLocation();
    const searchParams = new URLSearchParams(search);
    const registerToken = searchParams.get('token');
    // const email = searchParams.get('email');
    // const firstName = searchParams.get('firstName');
    // const lastName = searchParams.get('lastName');
    // const org = searchParams.get('org');

    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(SAVE_ACTION_TYPE));
            setShowSuccess(true);
        }
        if (successInviteForm) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_INVITE_FORM));
            navigate('/');
            open(
                <div style={{ width: 400 }}>
                    <div className="client-invited-successfully">
                        <img src={Images.successMarkIcon} alt="success" />
                        <p>Request sent</p>
                        <span>
                            Your provider has been notified. <br /> You’ll receive a new link soon.
                        </span>
                    </div>
                </div>
            );
        }
    }, [success, successInviteForm]);

    useEffect(() => {
        if (registerToken) {
            dispatch(formActions.getClientInviteForm(registerToken));
        }
    }, [registerToken]);

    const handleSaveAction = (data) => {
        dispatch(formActions.saveInviteForm(data, registerToken));
    };

    if (loader?.length) {
        return <Loader />;
    }

    return (
        <div className="client-invite-form-wrapper">
            <div className="client-invite-form-header-wrapper">
                <button onClick={() => navigate('/')}>
                    <img src={Images.backBtn} alt="back-btn" />
                </button>
                <div>
                    <p>Welcome! Please fill out the intake form below to get started.</p>
                    <span>(Required fields are marked with an asterisk.)</span>
                </div>
            </div>

            <div className="client-invite-form-body">
                <div className="client-invite-form-box">
                    <div className="client-invite-form-template">
                        {backError?.error === tokenIsExpired ? (
                            <div className="client-invited-successfully">
                                <img src={Images.alertError} alt="" />
                                <p>This link has expired</p>
                                <span>
                                    Your intake link has expired. <br />
                                    Please contact your provider to receive a new one.
                                </span>

                                <button className="request-new-link" onClick={() => dispatch(formActions.requestInviteForm(registerToken))}>
                                    {loadInviteForm?.length ? (
                                        <MinLoader margin="0" color={'#FFF'} position="relative" width={13} height={13} />
                                    ) : (
                                        'Request New Link'
                                    )}
                                </button>
                            </div>
                        ) : backError?.error === tokenIsInvalid ? (
                            <div className="client-invited-successfully">
                                <img src={Images.alertError} alt="error" />
                                <p>This link is no longer active</p>
                                <span>
                                    The form linked here has either expired, been used,
                                    <br /> or is no longer valid.
                                </span>
                            </div>
                        ) : backError?.error ? (
                            <div className="client-invited-successfully">
                                <img src={Images.alertError} alt="success" />
                                <p>Something went wrong!</p>
                                <span>
                                    We’ve received your information.
                                    <br />
                                    We’ll notify your provider, and they’ll get back to you soon.
                                </span>
                            </div>
                        ) : showSuccess ? (
                            <div className="client-invited-successfully">
                                <img src={Images.successMarkIcon} alt="success" />
                                <p>Thank You for Submitting Your Intake Form!</p>
                                <span>
                                    We’ve received your information.
                                    <br />
                                    We’ll notify your provider and they’ll get back to you soon.
                                </span>
                            </div>
                        ) : (
                            <FormBuilder
                                width={'100%'}
                                defaultForm={clientInviteForm}
                                afterSuccess={() => {}}
                                ACTION_TYPE={SAVE_ACTION_TYPE}
                                handleSaveNote={handleSaveAction}
                                actionName={'Submit Form'}
                                inviteToken={registerToken}
                                isClassicForm={true}
                            />
                        )}
                    </div>
                    <div className="invite-page_right-side">
                        <img src={Images.authImageSmall} alt="Auth Image" />
                        <img
                            src={Images.authImage}
                            alt="Auth Image"
                            style={{
                                opacity: imageLoaded ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                                visibility: imageLoaded ? 'visible' : 'hidden',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
